export { default } from './image'
